import apiClient from "../../axios/apiClient";


export const getInsuranceTPAList =
  (token, limit = 10, page = 1, search = "", sort = "desc",filters) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_INSURANCE_TPA_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Insurance-TPA`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            filters:filters
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_INSURANCE_TPA_LIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_INSURANCE_TPA_LIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveInsuranceTPAData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_INSURANCE_TPA_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Insurance-TPA`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_INSURANCE_TPA_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_INSURANCE_TPA_REJECTED", payload: error.response });
    }
  };
  

  export const getInsuranceTPAListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_INSURANCE_TPA_LIST_BY_ID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Insurance-TPA/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_INSURANCE_TPA_LIST_BY_ID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
        staticData: response.data?.staticData,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_INSURANCE_TPA_LIST_BY_ID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateInsuranceTPAData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_INSURANCE_TPA_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Insurance-TPA/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_INSURANCE_TPA_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_INSURANCE_TPA_REJECTED", payload: error.response });
  }
};


export const updateInsuranceTPAStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_INSURANCE_TPA_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Insurance-TPA-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_INSURANCE_TPA_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_INSURANCE_TPA_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteInsuranceTPAData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_INSURANCE_TPA_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Insurance-TPA/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_INSURANCE_TPA_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_INSURANCE_TPA_REJECTED", payload: error.response });
  }
};

export const saveAuthorityLetterTPAData = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "SAVE_AUTHORITY_LETTER_TPA_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Company-Document-TPA`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "SAVE_AUTHORITY_LETTER_TPA_FULFILLED", payload: response.data });
  } catch (error) {
    console.log(error.response?.data);
    dispatch({ type: "SAVE_AUTHORITY_LETTER_TPA_REJECTED", payload: error.response });
  }
};

export const uploadCompanyAuthorityLetterTPA = (token, formData, isReportFormat = false) => async (dispatch) => {
  try {
    dispatch({ type: "UPLOAD_COMPANY_AUTHORITY_LETTER_TPA_PENDING" });

    const docType =
      typeof isReportFormat === "string"
        ? isReportFormat
        : isReportFormat
          ? "reportFormat"
          : "authorityLetter";

    const endpoint =
      docType === "reportFormat"
        ? `/api/admin/v1/Upload-Company-Report-Format-TPA`
        : docType === "requirementLetter"
          ? `/api/admin/v1/Upload-Company-Requirement-Letter-TPA`
          : `/api/admin/v1/Upload-Company-Authority-Letter-TPA`;

    const response = await apiClient.post(
      endpoint,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: "UPLOAD_COMPANY_AUTHORITY_LETTER_TPA_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "UPLOAD_COMPANY_AUTHORITY_LETTER_TPA_REJECTED",
      payload: error.response,
    });
  }
};

